<script lang="ts" setup>
import { useDefaultSettingsStore } from "~/stores/defaultSettingsStore"
import MenuSubHeader from "./MenuSubHeader.vue"
import { SUPPORTED_PAGES_ENUM } from "~/types/breadcrumb"
const $q = useQuasar()
const i18n = useI18n()

/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */
const defaultSettingsStore = useDefaultSettingsStore()
const { settings } = storeToRefs(defaultSettingsStore)

const information = computed(() => {
    return settings.value?.information
})

const menuItems = computed(() => [
{
        route: "/information/term_conditions",
        name: i18n.t("settings.terms_conditions"),
        page:SUPPORTED_PAGES_ENUM.TermsConditions,
        isHidden:!information.value?.enable_term_conditions,
    },
    {
        route: "/information/shipment_policy",
        name:i18n.t("settings.shipment_policy"),
        page:SUPPORTED_PAGES_ENUM.ShipmentPolicy,
        isHidden:!information.value?.enable_shipment_policy,
    },
    {
        route: "/information/return_policy",
        name:i18n.t("settings.return_policy"),
        page:SUPPORTED_PAGES_ENUM.ReturnPolicy,
        isHidden:!information.value?.enable_return_policy,
    },
    {
        route: "/frequent-ask",
        name: i18n.t("home.faq"),
        page: SUPPORTED_PAGES_ENUM.FAQ,
        isHidden: !information.value?.enable_frequent_asks,
    }
   
])

const contacts = computed(() => settings.value?.contacts)


/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

function openNetwork(url: string) {
    window.open(url)
}
</script>
<template>
    <div class="tw-bg-primary tw-py-1 tw-text-center tw-z-[1000] tw-w-full">
    </div>
    <div class="tw-bg-white  tw-py-8 footer-link">
        <div class="tw-flex tw-justify-between tw-gap-8 max-container">
            <img :src="contacts.logo_path" alt="logo homedeli" class="tw-h-10 xl:tw-h-20 tw-w-auto">
            <!-- <HomeMenu class="tw-hidden lg:tw-flex"></HomeMenu> -->
            <div class="xl:tw-flex tw-gap-x-4 tw-gap-y-2 tw-flex-wrap tw-hidden tw-justify-center" v-for="item in menuItems" :key="item.name">
                <a :href="item.route" v-if="!item.isHidden"   class="tw-no-underline tw-font-menu tw-self-center tw-text-black hover:tw-text-opacity-60">{{ item.name }}</a>
            </div>
            <div class="tw-flex tw-flex-col tw-self-center">
                <div class="tw-flex tw-justify-between tw-text-2xl tw-gap-8">
                    <a class="tw-text-primary" :href="contact.url" v-for="contact in contacts.networks">
                        <q-icon :name="contact.icon" class="tw-text-3xl lg:tw-text-4xl hover:tw-text-secondary"></q-icon>
                    </a>
                </div>
                <span class="tw-font-body tw-text-xs xl:tw-text-sm tw-opacity-70 tw-tracking-wider tw-text-black">homedeli 2025.{{ $t('landing.all-right') }}</span>
            </div>
        </div>
        <div class="tw-flex tw-gap-x-4 tw-gap-y-2 tw-justify-center tw-flex-wrap xl:tw-hidden tw-w-full tw-px-8 tw-mt-4">
            <a v-for="item in menuItems" :key="item.name" :href="item.route"   class="tw-no-underline tw-font-menu tw-self-center tw-text-black hover:tw-text-opacity-60">{{ item.name }}</a>
        </div>
    </div>
</template>

<style>

</style>
